/// <reference lib="dom" />

import { err, ok, type Result } from "neverthrow"
import { serializeFusionError, type FusionError } from "./error/FusionError"

export const proposeMountRenderer = (renderer: number): Result<void, string> => {
	// [ISSUE-1224]
	// Renderers 7 and earlier were used only for testing and initial
	// launch of Form Versioning; all production forms were upgraded to
	// Renderer 8, which is compatible with the newer Import/Export
	// endpoints that speak Concept instead of Prompt/Response.
	if(renderer < 8) {
		return err('Renderers < 8 are no longer in use; please contact support.')
	}
	return ok()
}

// check if an alternate hotfixed renderer is required to fix print issues
export const proposeUseOriginalRendererForDocgen = (branchRenderer: number): Result<void, number> => {
	switch(branchRenderer) {
		case 34:
			return err(40)
		case 38: 
			return err(41)
		default:
			return ok()
	}
}

// execute post render hacks if required to fix print issues
export const executePostRenderHacksForDocgen = (branchRenderer: number): Result<void, FusionError> => {
	// dan's old renderer hacks to remove page breaks and expand text areas
	// before the pdf went from multiple pages to one super long page
	if(branchRenderer < 42) {
		/* dan's original gotenberg code 20260531
		const printLoadingWait = "(function(){" +
			"var w=window,d=document;" +
			"var pl=d.getElementById('print-loading');" +
			"if(pl)return false;" +
			"if(!w.__fusionPrintCssInjected){" +
			"var s=d.createElement('style');" +
			"s.textContent='*{break-before:avoid!important;break-after:avoid!important;page-break-before:avoid!important;page-break-after:avoid!important;}';" +
			"d.head.appendChild(s);" +
			"w.__fusionPrintCssInjected=true;" +
			"w.__fusionPrintLastH=-1;" +
			"w.__fusionPrintLastChangeAt=Date.now();" +
			"return false;" +
			"}" +
			"d.querySelectorAll('textarea').forEach(function(el){" +
			"if(el.scrollHeight<=el.clientHeight)return;" +
			"var cs=getComputedStyle(el);" +
			"var adj=cs.boxSizing==='border-box'?parseFloat(cs.borderTopWidth)+parseFloat(cs.borderBottomWidth):-(parseFloat(cs.paddingTop)+parseFloat(cs.paddingBottom));" +
			"el.style.height=(el.scrollHeight+adj)+'px';" +
			"});" +
			"var h=d.documentElement.scrollHeight;" +
			"if(h!==w.__fusionPrintLastH){" +
			"w.__fusionPrintLastH=h;" +
			"w.__fusionPrintLastChangeAt=Date.now();" +
			"return false;" +
			"}" +
			"return Date.now()-w.__fusionPrintLastChangeAt>=2500;" +
			"})()"
		*/
		const styleBlock = document.createElement('style')
		styleBlock.textContent = `
			* {
				break-before: avoid !important;
				break-after: avoid !important;
				page-break-before: avoid !important;
				page-break-after: avoid !important;
			}
		`
		document.head.appendChild(styleBlock)
		document.querySelectorAll('textarea').forEach((el) => {
			if(el.scrollHeight <= el.clientHeight) {
				// box already shows all content
				return
			}
			// resize to show all content
			const cs = getComputedStyle(el)
			let height = el.scrollHeight
			switch(cs.boxSizing) {
				case 'border-box':
					height += parseFloat(cs.borderTopWidth)
					height += parseFloat(cs.borderBottomWidth)
					break
				default:
					height += parseFloat(cs.paddingTop)
					height += parseFloat(cs.paddingBottom)
					break
			}
			el.style.height = `${height}px`
		})
	}
	// [ISSUE-1901] On 2026 PDFs change "Evaluator" to "Completed By"
	// expect exactly one div containing the text "Evaluator"
	if(branchRenderer >= 42 && branchRenderer <= 66) {
		const evalEls = [...document.querySelectorAll('span')]
			.filter(el => el.textContent.trim() === 'Evaluator')
		if(evalEls.length !== 1) {
			return err(serializeFusionError(
				'executePostRenderHacksForDocgen',
				`[ISSUE-1901] expected 1 <span>Evaluator</span> element, got ${evalEls.length}`
			))
		}
		evalEls[0].textContent = 'Completed By'
	}
	return ok()
}
